export default __webpack_public_path__ + "static/media/0.49ecf539.png";